/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2CheckCircleHollow/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2CheckCircleHollow({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2CheckCircleHollow",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 12,
  height = 12,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  stroke = "#2F8132"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2CheckCircleHollow.Svg"
  data-view-path={viewPath}
 viewBox="0 0 12 12"
 style={{'--as-1-Ze3Kc4': alignSelf,'--mt-2-Ze3Kc4': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Ze3Kc4': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Ze3Kc4': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Ze3Kc4': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Ze3Kc4': opacity,'--w-10-Ze3Kc4': typeof width === 'number' ? `${width}px` : width,'--h-11-Ze3Kc4': typeof height === 'number' ? `${height}px` : height,'--f-12-Ze3Kc4': fill,'--a-7-Ze3Kc4': isAnimated ? animation : "none",'--sd-8-Ze3Kc4': isAnimated ? strokeDashoffset : 0,'--sd-9-Ze3Kc4': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2CheckCircleHollow.SvgPath"
  data-view-path={viewPath}
 d="M6 11A5 5 0 106 1a5 5 0 000 10z"
 strokeLinecap="round"
 strokeLinejoin="round"
 style={{'--s-13-Ze3Kc4': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
<path
  data-testid="Tysiav2CheckCircleHollow.SvgPath:1"
  data-view-path={viewPath}
 d="M8.244 4.266L5.167 8.112 3.63 6.958"
 strokeLinecap="round"
 strokeLinejoin="round"
 style={{'--s-13-Ze3Kc4': stroke}}
 className={`views-block ${styles.SvgPath1}`}
/>
</svg>
{children}
</React.Fragment>)
}